(function () {
    'use strict';

    angular
        .module('admin')
        .controller('AdmJobDescriptionListController', AdmJobDescriptionListController);

    AdmJobDescriptionListController.$inject = ['AdmService','$uibModal'];

    function AdmJobDescriptionListController(AdmService, $uibModal) {
        var vm                              = this;
        vm.activate                         = activate;
        vm.getByFilter                      = getByFilter;
        vm.search                           = '';
        vm.queryFlag                        = false;
        vm.deleteJobDescription             = deleteJobDescription;
        vm.openEditModal                    = openEditModal;
        vm.getDepartmentsForSelect          = getDepartmentsForSelect;
        vm.departmentSelected               = {id : -1, name : '--- All ---'};
        vm.responsibilitiesSelected         = [];
        vm.getResponsibilitiesForSelect     = getResponsibilitiesForSelect;
        vm.getJobDescriptionsForSelect      = getJobDescriptionsForSelect;
        vm.positionSelected                 = [];
        vm.admUserSelected                  = [];
        vm.getAdmUsersStaff                 = getAdmUsersStaff;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function getDepartmentsForSelect()
        {
            AdmService.getDepartmentsForSelect(vm.query).then(function(response){
                vm.queryFlag    = true;
                vm.departments  = response.data;
                vm.departments.unshift({id : -1, name : '--- All ---'});
            }).catch(function(err) {

            });
        }

        function getResponsibilitiesForSelect()
        {
            AdmService.getResponsibilitiesForSelect(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.responsibilities = response.data;
            }).catch(function(err) {

            });
        }

        function getJobDescriptionsForSelect()
        {
            AdmService.getJobDescriptionsForSelect().then(function(response){
                vm.queryFlag        = true;
                vm.jobDescriptions = response.data;
                vm.positions        = response.data;
            }).catch(function(err) {

            });
        }

        function getByFilter()
        {
            vm.queryFlag        = false;
            vm.query            = {};
            vm.query['page']    = vm.page;
            if(typeof vm.positionSelected !== 'undefined' && vm.positionSelected.length > 0) {
                if (vm.positionSelected)
                {
                    vm.query['position'] = [];
                    angular.forEach(vm.positionSelected, function(value, key) {
                        vm.query['position'].push({id: value.id});
                    });
                    vm.query['position'] = JSON.stringify(vm.query['position']);
                }
            }
            if(typeof vm.departmentSelected !== 'undefined') {
                vm.query['department']  = vm.departmentSelected;
            }
            if(typeof vm.responsibilitiesSelected !== 'undefined' && vm.responsibilitiesSelected.length > 0) {
                if (vm.responsibilitiesSelected)
                {
                    vm.query['responsibilities'] = [];
                    angular.forEach(vm.responsibilitiesSelected, function(value, key) {
                        vm.query['responsibilities'].push({id: value.id});
                    });
                    vm.query['responsibilities'] = JSON.stringify(vm.query['responsibilities']);
                }
            }
            if(typeof vm.search !== 'undefined' && vm.search !== '') {
                vm.query['description']  = vm.search;
            }
            if(typeof vm.admUserSelected !== 'undefined' && vm.admUserSelected !== '') {
                vm.query['adm_user_id']  = vm.admUserSelected;
            }
            AdmService.getJobDescriptions(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.jobDescriptions  = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {

            });
        }

        function deleteJobDescription(jobDescription){
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to delete this job description: ' + department.name+'?')
                .set('onok', function (){
                    AdmService.deleteJobDescription(jobDescription.id).then(function () {
                        vm.jobDescriptions.splice(vm.jobDescriptions.indexOf(jobDescription), 1);
                        alertify.notify('Job Description is successfully deleted', 'success', 3);
                    });
                })
                .show();
        }

        function openEditModal(jobDescription) {

            $uibModal.open({
                templateUrl: 'templates/adm/jobDescription/edit/template.modal.html',
                controller: 'AdmJobDescriptionEditController',
                controllerAs:'vm',
                resolve:
                    {
                        jobDescription : function () {
                            return jobDescription;
                        },
                        admJobDescriptionList : function()
                        {
                            return vm;
                        }
                    }
            });
        }

        function getAdmUsersStaff()
        {
            vm.query = {};
            AdmService.getAdmUsersStaff(vm.query).then(function(response){
                vm.admUsers  = response.data;
                vm.admUsers.unshift({id : -1, name : '--- All ---'});
            }).catch(function(err) {

            });
        }

        function activate() {
            vm.getDepartmentsForSelect();
            vm.getResponsibilitiesForSelect();
            vm.getJobDescriptionsForSelect();
            vm.getAdmUsersStaff();
            vm.getByFilter();
        }
        vm.activate();
    }

})();